module.exports = __webpack_public_path__ + "static/media/b1_author_woah.a188e054.mp3";